import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Compose Tailwind class strings with conflict resolution.
 *
 * Use this everywhere instead of `[a, b].filter(Boolean).join(' ')` so
 * later overrides actually beat earlier defaults. E.g. `cn('px-3', x.cls)`
 * lets a caller pass `className="px-4"` and win.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
